'use strict';

export default function f(alert, Storage) {
  'ngInject';

  const SEND_OFFERS_KEY = 'sa_send_offers_alert';
  var localStorage = new Storage('local');

  // TODO: extract openedOnce to a service?
  var openedOnce = function () {
    var data = localStorage.get(SEND_OFFERS_KEY);
    if (data) {
      return true;
    } else {
      data = 1;
      localStorage.set(SEND_OFFERS_KEY, data);
      return false;
    }
  };

  return {
    show() {
      if (openedOnce()) { return; }

      alert.show({
        header: 'SEND_OFFER_MODAL.SEND_OFFERS.HEADER',
        body: 'SEND_OFFER_MODAL.SEND_OFFERS.BODY',
        buttons: [
          {
            label: 'SEND_OFFER_MODAL.SEND_OFFERS.LABEL',
            action: 'accept'
          }
        ]
      });
    },
  };
}



// WEBPACK FOOTER //
// ./app/src/components/trips/common/send_offer_success_alert.js